import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSoundWave16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSoundWave16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 13.56V2.444a.5.5 0 1 1 1 0V13.56a.5.5 0 0 1-1 0M5 11.5v-7a.5.5 0 0 1 1 0v7a.5.5 0 1 1-1 0m4-7v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0m-5.5 2A.5.5 0 0 1 4 7v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5M12 7a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm-10.5.002a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5M14 7.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSoundWave16);
